import styled from '@emotion/styled';
import { IconButton } from '@material-ui/core';

const RemoveAttachmentButton = styled(IconButton)({
  margin: -12,
  marginLeft: 0
});

export default RemoveAttachmentButton;
